import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { slugify } from 'util/seo';
import { Link } from 'react-router-dom';
import premiumIco from 'images/premium_badge.png';
import playIcon from 'images/ic-audio-play-1.png';
import './BundleItem.scss';

function BundleItem({ bundle, className, onSelect }) {
  const { id, name, description, thumb_path, is_premium, type } = bundle;
  const bundle_path = type === 'audio' ? '/audio-bundle' : '/image-bundle';
  return (
    <div className={classNames('bundle-item d-flex flex-column mb-5', className)}>
      <div
        className="thumbnail"
        style={{
          backgroundImage: `url(${thumb_path})`
        }}
      >
        <div className="overlay">
          <div className="title">{name}</div>
        </div>
        {is_premium && type !== 'audio' && (
          <img className="premium-badge" src={premiumIco} alt="premium" title="Premium" />
        )}
      </div>
      <div className="bundle-detail-link d-flex align-self-center">
        {type === 'audio' && (
          <Link to={`${bundle_path}/${id}/${slugify(name)}`} className="btn btn-play" onClick={() => onSelect(bundle)}>
            <img src={playIcon} alt="" />
          </Link>
        )}
        <Link to={`${bundle_path}/${id}/${slugify(name)}`} className="btn btn-green" onClick={() => onSelect(bundle)}>
          View Pack
        </Link>
      </div>
      <h4 className="mt-1 mb-2">{name}</h4>
      <p className="truncate-overflow mb-0">
        {description && description.length > 90 ? description.substring(0, 90) + ' ...' : description}
      </p>
    </div>
  );
}

BundleItem.propTypes = {
  bundle: PropTypes.object.isRequired
};

export default BundleItem;
